import { render, staticRenderFns } from "./TitleAddAgenda.vue?vue&type=template&id=74421af0"
import script from "./TitleAddAgenda.vue?vue&type=script&lang=js"
export * from "./TitleAddAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports